import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    INTERFACE_ON_OFF: 'on',
    cache: [],
    myLivingFaceImgUrl: '',
    myLivingFacePopupStatus: false,
    myLivingFaceAccessToken: '',
    myLivingFaceCustomerId: '',
    myLivingFaceVerifyType: 0,
    myLivingFaceType: 0,
  },
  getters: {
    getCache: state => {
      return state.cache;
    },
    livingFaceImgUrl: state => {
      return state.myLivingFaceImgUrl;
    },
    livingFacePopupStatus: state => {
      return state.myLivingFacePopupStatus;
    },
    livingFaceAccessToken: state => {
      return state.myLivingFaceAccessToken;
    },
    livingFaceCustomerId: state => {
      return state.myLivingFaceCustomerId;
    },
    livingFaceVerifyType: state => {
      return state.myLivingFaceVerifyType;
    },
    livingFaceType: state => {
      return state.myLivingFaceType;
    },
  },
  mutations: {
    setCache: (state, val) => {
      state.cache.push(val);
      const unique = function (arr) {
        const n = [];
        for (let i = 0; i < arr.length; i++) {
          if (n.indexOf(arr[i]) === -1) n.push(arr[i]);
        }
        return n;
      };
      state.cache = unique(state.cache);
    },
    delCache: (state, val) => {
      const i = state.cache.indexOf(val);
      (i > -1) && state.cache.splice(i, 1);
    },
    setLivingFaceImgUrl: (state, val) => {
      state.myLivingFaceImgUrl = val;
    },
    setLivingFacePopupStatus: (state, val) => {
      state.myLivingFacePopupStatus = val;
    },
    setLivingFaceAccessToken: (state, val) => {
      state.myLivingFaceAccessToken = val;
    },
    setLivingFaceCustomerId: (state, val) => {
      state.myLivingFaceCustomerId = val;
    },
    setLivingFaceVerifyType: (state, val) => {
      state.myLivingFaceVerifyType = val;
    },
    setLivingFaceType: (state, val) => {
      state.myLivingFaceType = val;
    },
  },
  actions: {},
});
